import { Graph, BasicInfo, Documents, Terms } from './components';

export const steps = [
  {
    name: 'GRAPH',
    label: 'Συνοπτική Παρουσίαση Κατάστασης',
    Component: Graph,
    id: 1,
  },
  {
    name: 'INFO',
    label: 'Επενδυτικό Σχέδιο',
    Component: BasicInfo,
    id: 2,
  },
  {
    name: 'DOCUMENTS',
    label: 'Δικαιολογητικά',
    Component: Documents,
    id: 3,
  },

  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: Terms,
    id: 4,
  },
];
